import { Text } from '@/components/TextComponent';
import { Column, Row } from '@/components/lib/components';
import { ds } from '@/components/lib/design.system';
import { TennisServingDot } from '@/components/scoreboard/sports/tennis';

import { TEAM_ROW_HEIGHT } from '../parts/TeamInfoRow';
import { TeamLogo } from '../parts/TeamLogo';
import { TennisScoreboard, TennisSetScore } from './TennisScoreboard';

type TennisPlayerRowProps = {
    playerName: string;
    logoUrl: string;
    primaryColor: string;
    secondaryColor: string;
    shouldShowFallbackLogo: boolean;
    isServing?: boolean;
    setScores?: TennisSetScore[];
    gameScore?: number | string;
};

export const TennisPlayerRow = ({
    playerName,
    logoUrl,
    primaryColor,
    secondaryColor,
    shouldShowFallbackLogo,
    isServing,
    setScores,
    gameScore,
}: TennisPlayerRowProps) => {
    return (
        <Row height={TEAM_ROW_HEIGHT} alignItems="center" gap="s8">
            <TeamLogo
                logoUrl={logoUrl}
                primaryColor={primaryColor}
                secondaryColor={secondaryColor}
                shouldShowFallbackLogo={shouldShowFallbackLogo}
            />
            <Row justifyContent="space-between" flex={1} gap="s12" alignItems="center">
                <Column flexShrink={1}>
                    <Row gap="s6" alignItems="center">
                        <Text variant="titleMedium" color={ds.colorToken.text.primary} numberOfLines={1} flexShrink={1}>
                            {playerName}
                        </Text>
                        {isServing ? <TennisServingDot /> : null}
                    </Row>
                </Column>
                {setScores && setScores.length > 0 ? (
                    <TennisScoreboard setScores={setScores} gameScore={gameScore} />
                ) : null}
            </Row>
        </Row>
    );
};
